import React from "react";
import Typography from "@material-ui/core/Typography";
const Outlet = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Outlet
      </Typography>
      <Typography paragraph variant="h5">
        Manage outlet master data to simplify daily operational
      </Typography>
      <Typography paragraph variant="body1">
        Outlet is one of the features under the Sales module to manage outlet
        master data which is ready to operate daily retail sales. It contains
        any information regarding the outlet location, currency used for
        transactions, address details of each outlet, and product selling price
        setup which sold on each outlet.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Outlet list. It
        is displayed like a table that contains download functions, sort,
        filter, and global search on the header area, and contains data
        navigation and refresh function on the footer area. The data column that
        appears in this table list are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Outlet ID</b>
        <br />
        Indicates the ID of the Outlet.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Outlet Name</b>
        <br />
        Indicates the full name of the Outlet.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Phone Number</b>
        <br />
        Indicates the contact phone number of the Outlet.
      </Typography>
      <Typography paragraph variant="body1">
        <b>City</b>
        <br />
        Indicates the city location of the Outlet.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Currency</b>
        <br />
        Indicates the used currency of the Outlet.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 4 buttons that appear on each row of Outlet data with
        specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Whatsapp Chat Outlet</b>
        <br />
        This button only appears if the Outlet has a valid phone number. It is
        used to automatically redirect to WhatsApp API to send a conversation to
        the Outlet.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit Outlet</b>
        <br />
        This button is used to edit the Outlet data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Outlet Point of Sales Setting</b>
        <br />
        This button is used to navigate to the Outlet detail and Point of Sales
        setup which contains some tabs with details below:
        <ul>
          <li>
            <b>Basic Info</b> : This tab is to display the Outlet data.
          </li>
          <li>
            <b>Point of Sales</b> : This tab is to setup the Point of Sales used
            in the Outlet daily operation. It has 2 functions with details
            below:
            <ul>
              <li>
                <b>Items Selling Price</b> : This tab is to setup the product
                prices sold in the Outlet.
              </li>
              <li>
                <b>POS Cash Setup</b> : This tab is to setup the cash accounts
                or payment methods used for transactions with the customer.
              </li>
            </ul>
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete Outlet</b>
        <br />
        This button is used to delete the Outlet data. The Outlet data is
        undeletable once it have transactions.
      </Typography>
    </React.Fragment>
  );
};

export default Outlet;
